import { Disclosure } from '@headlessui/react';
import { Icon } from '../../atoms/Icon';
import { Typography } from '../../molecules/Typography';
import { cnBase } from 'tailwind-variants';

interface AccordionCardProps {
  icon?: React.ReactNode;
  title: React.ReactNode | string;
  children?: React.ReactNode;
  headerChildren?: React.ReactNode;
  chevronIcon?: string;
  shadow?: string;
  className?: string;
  'data-tour'?: string;
  chevronDataTour?: string;
}

export function AccordionCard({
  icon,
  title,
  children,
  headerChildren,
  chevronIcon = 'chevron_right',
  shadow,
  className,
  'data-tour': dataTour,
  chevronDataTour,
}: AccordionCardProps) {
  const chevronRotate =
    chevronIcon === 'chevron_right'
      ? 'rotate-90 transform'
      : 'rotate-180 transform';

  return (
    <Disclosure>
      {({ open }) => (
        <div
          data-tour={dataTour}
          className={cnBase(
            `flex w-full min-w-fit flex-col gap-xxl rounded-md bg-color-lightest p-4 md:px-8 md:py-4`,
            shadow,
            className,
          )}
        >
          <Disclosure.Button className={'flex items-center gap-md'}>
            <div className='flex w-full items-center justify-between gap-md'>
              {typeof title === 'string' ? (
                <div className='flex items-center gap-sm'>
                  {icon && icon}
                  <Typography weight='bold' className='text-left'>
                    {title}
                  </Typography>
                </div>
              ) : (
                title
              )}
              {headerChildren}
            </div>
            <span data-tour={chevronDataTour}>
              <Icon
                type='material'
                Icon={chevronIcon}
                className={`text-mono-color-black ${open ? chevronRotate : ''}`}
              />
            </span>
          </Disclosure.Button>

          <Disclosure.Panel>{children}</Disclosure.Panel>
        </div>
      )}
    </Disclosure>
  );
}
